<ion-buttons>
  <ion-button (click)="handleBack($event)" aria-label="Go back" i18n-aria-label>
    <aaa-icon slot="start" color="dark" name="chevron-left"></aaa-icon>
    <aaa-text color="dark" i18n>Back</aaa-text>
  </ion-button>
</ion-buttons>
